import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import Link from "next/link";
import { NavItem } from "./NavBar";

export default function MobileNavMenu({
  close,
  items,
  activeItem,
}: {
  close: () => void;
  items: NavItem[];
  activeItem: string | undefined;
}) {
  return (
    <Disclosure>
      <Disclosure.Button
        as="a"
        className={clsx(
          "cursor-pointer text-white hover:bg-succinct-teal-20",
          "flex flex-row items-center justify-between rounded-md py-2 px-3 text-base font-medium"
        )}
      >
        Light Clients
        <ChevronDownIcon className={clsx("ml-2 h-5 w-5")} aria-hidden="true" />
      </Disclosure.Button>
      <Disclosure.Panel>
        {items.map(({ name, path, id }) => (
          <Link
            onClick={close}
            key={name}
            href={path}
            className={clsx(
              "text-white hover:bg-succinct-teal-20",
              "block rounded-md py-2 px-3 pl-6 text-base font-medium",
              id === activeItem && "bg-succinct-teal-20"
            )}
          >
            {name}
          </Link>
        ))}
      </Disclosure.Panel>
    </Disclosure>
  );
}
